import * as modules from './module'
import * as constants from './utils/constants'
import PKGJson from '../package.json'
import locale from '@/locale'

const install = (Vue, opts = {}) => {
  locale.use(opts.locale)
  locale.i18n(opts.i18n)
  Vue.prototype.$constants = constants
  if (opts.all) {
    Object.keys(modules).forEach(k => {
      Vue.use(modules[k])
    })
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}

const version = PKGJson.version

export default {
  version,
  install
}

export * from './module'



// WEBPACK FOOTER //
// ./src/index.js